import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientsService } from 'app/services/client/ClientsService';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'app/globals';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

    passwordIsValid = false;

    userId: number;
    userInfo = {
        Email: "",
        password1: "",
        password2: ""
    };
    pageIndex: number = 1;
    securityQuestions: any[] = [];
    questionsLoaded: boolean = false;
    code: string;
    isValidResetCode: boolean;
    loading = false;

    constructor(
        private _ClientsService: ClientsService,
        private _activatedRoute: ActivatedRoute,
        private _toastr: ToastrService,
        private _router: Router,
        private _Globals: Globals
    ) {
        const routeData = this._activatedRoute.snapshot.data as { resolveData: { userEmail: string, validCode: boolean } };
        this.isValidResetCode = routeData.resolveData.validCode;
        this.userInfo.Email = routeData.resolveData.userEmail;

        this._Globals.setMode("");//disable the side menu
        this._Globals.setAvailableModes("");
        this._Globals.setUserType("");

        this._activatedRoute.params.subscribe(params => {
            console.log('id', params['id']);
            console.log('code', params['code']);
            this.userId = parseInt(params['id']);
            this.code = params['code'];
        });
    }

    ngOnInit() {
    }

    preventSpace(value: string, event: any, id?: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }

        if (id == undefined) {
            id = event.target.id;
        }
        if (value == " ") {
            $('#' + id + '').val('');
        }
    }

    confirmationFail() {
        if (this.userInfo.password1 == "" && this.userInfo.password2 == "") {
            $('#errorPasswordMessage').text('');
        }

        if (this.userInfo.password1 != "" && this.userInfo.password2 != "") {
            if (this.userInfo.password1 !== this.userInfo.password2) {
                this._toastr.warning("Confirm password must be the same as the new password", "ELI");
                $('#errorPasswordMessage').text('Confirm password does not match');
                $('.pass2').removeClass('passMatch');
                $('.pass2').addClass('passNotMatch');
            } else {
                $('#errorPasswordMessage').text('');   
                $('.pass2').removeClass('passNotMatch');
                $('.pass2').addClass('passMatch');
            }
        }
    }

    removeMessage() {
        $('#errorPasswordMessage').text('');
    }

    updatePassword() {
        $('body').css('cursor', 'progress');
        this._ClientsService.postUpdatePassword(this.userInfo.Email, this.userInfo.password1).subscribe((data: any) => {
            console.log('postUpdatePassword', data);
            $('body').css('cursor', 'default');
            if (data.result == 1) {
                this._Globals.userEmail = this.userInfo.Email;
                this._toastr.success('Password updated successfully.', 'ELI');
                this._router.navigate(['/login']);
                this._ClientsService.postRedeemPasswordCode(this.code).subscribe();
            } else {
                this._toastr.error('We are sorry.  An error happened while trying to reset the password', 'ELI');
            }
        });
    }

    validForm() {
        console.log('validForm');
        if ((this.userInfo.password1 !== this.userInfo.password2) || (this.userInfo.password1 == "" && this.userInfo.password2 == "")) {
            $('.pass2').removeClass('passMatch');
            $('.pass2').addClass('passNotMatch');
            return false;
        } else {
            $('.pass2').removeClass('passNotMatch');
            $('.pass2').addClass('passMatch');
        }
        return true;
    }

    passwordValid(event) {
        this.passwordIsValid = event;
    }

    public GenerateNewLink(): void {
        this.loading = true;
        let isValid = this.validateEmail(this.userInfo.Email);
        if (!isValid) {
            this.loading = false;
            return;
        } 

        console.log('valid email');
        this.forgotPassword(this.userInfo.Email);
    }

    validateEmail(email: string): boolean {
        $('body, .btn-primary').css('cursor', 'wait');
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let validEmail = regex.test(email);
        console.log('Valid', validEmail)
        if (validEmail) {
            return true;
        } else {
            this._toastr.warning('Please enter a valid email address', "ELI");
            $('body, .btn-primary').css('cursor', 'default');
            return false;
        }
    }

    forgotPassword(email: string) {
        this._ClientsService.postForgotPassword(email).subscribe((data: any) => {
            console.log("_PostForgotPassword response", data);            

            switch (data.result.Result) {
                case 1:
                    this._toastr.success("An email message with your password has been sent to the provided email address.", "ELI");
                    break;
                case 0:
                    this._toastr.error("We are sorry. An error happened while trying to recover your password.", "ELI");
                    break;
                case -1:
                    this._toastr.warning("No user account found for the provided email address.", "ELI");
                    break;
                case -2:
                    this._toastr.success('You have not activated your account. We have resent your last assessment assignment invitation email so you can use the link and password provided there in order to activate your account and access your assessment.', 'ELI');
                    break;
                case -3:
                    this._toastr.warning('You have not activated your account and your coach has not yet assigned any assessments to you.', 'ELI');
                    break
                case -4:
                    this._toastr.error(`Forgot password feature is not available for hub users. Please contact iPEC's customer support for assistance`, 'ELI');
            }

            this._router.navigate(['/login']); 
            $('body, .btn-primary').css('cursor', 'default');
        },
        (error) => {
            this.loading = false;
        },
        () => {
            this.loading = false;
        })
    }
}
